import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../../../../../../../redux/store";
import { fetchPages, upsertPage } from "../../../../../../../redux/blogSlice";

const EditPage: React.FC = () => {
  const { pageId } = useParams<{ pageId: string }>();
  const dispatch = useDispatch<AppDispatch>();
  const pages = useSelector((state: RootState) => state.blog.pages);

  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);

  const page = pages.find((p) => p.id === pageId);

  useEffect(() => {
    dispatch(fetchPages());
  }, [dispatch]);

  useEffect(() => {
    if (page) {
      setTitle(page.title);
      setSlug(page.slug);
      setContent(page.content);
    }
  }, [page]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    await dispatch(upsertPage({ id: pageId, title, slug, content })).unwrap();
    setLoading(false);
  };

  if (!page) return <div style={styles.message}>Loading page...</div>;

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Edit Page</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Title</label>
        <input
          style={styles.input}
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="e.g. About Us"
        />

        <label style={styles.label}>Slug</label>
        <input
          style={styles.input}
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          placeholder="e.g. about-us"
        />

        <label style={styles.label}>Content</label>
        <textarea
          style={styles.textarea}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          placeholder="Write your page content here..."
        />

        <button style={styles.button} type="submit" disabled={loading}>
          {loading ? "Updating..." : "Publish Updates"}
        </button>
      </form>
    </div>
  );
};

export default EditPage;

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    padding: "2rem",
    background: "linear-gradient(160deg, #0a0014, #1e003a, #a78bfa, #111)",
    color: "#fff",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', sans-serif",
  },
  heading: {
    fontSize: "24px",
    fontWeight: 700,
    marginBottom: "1.5rem",
    textAlign: "center",
  },
  form: {
    maxWidth: 600,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    backgroundColor: "rgba(255,255,255,0.05)",
    padding: "1.5rem",
    borderRadius: 12,
    boxShadow: "0 8px 30px rgba(168, 85, 247, 0.1)",
  },
  label: {
    fontWeight: "bold",
    fontSize: "14px",
  },
  input: {
    padding: "10px",
    borderRadius: 8,
    border: "1px solid #555",
    background: "#1e1e2f",
    color: "#fff",
  },
  textarea: {
    padding: "10px",
    minHeight: 140,
    borderRadius: 8,
    border: "1px solid #555",
    background: "#1e1e2f",
    color: "#fff",
  },
  button: {
    background: "linear-gradient(to right, #a78bfa, #c084fc)",
    color: "#000",
    padding: "10px",
    border: "none",
    borderRadius: 8,
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.3s",
  },
  message: {
    textAlign: "center",
    marginTop: "3rem",
    color: "#ccc",
  },
};